import { useState } from "react";
import { Link, useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { ReviewDone, ReviewForm } from "@/components/reviews/ReviewForm";
import { VerifiedNotice } from "@/components/reviews/ReviewsSection";
import { api } from "@/lib/api";
import { formatApiError } from "@/lib/format";
import { Seo } from "@/components/seo/Seo";
import { SEO } from "@/data/seo";

const Invalid = ({ message }) => (
  <div className="max-w-2xl" data-testid="review-link-invalid">
    <h1 className="font-display text-4xl font-medium text-navy sm:text-5xl">Link non disponibile</h1>
    <p className="mt-5 text-lg text-slate2">{message} Per aiuto scrivici dalla pagina Contatti.</p>
    <Link to="/contatti" className="btn-primary mt-10">Vai ai contatti</Link>
  </div>
);

export default function ReviewOrder() {
  const { token } = useParams();
  const [done, setDone] = useState([]);
  const query = useQuery({ queryKey: ["review-order", token], queryFn: async () => (await api.get(`/reviews/order/${token}`)).data, retry: false });
  const items = Array.isArray(query.data?.items) ? query.data.items : [];
  const markDone = (slug) => setDone((prev) => [...prev, slug]);

  return (
    <div className="bg-ivory pb-28 pt-40" data-testid="review-order-page">
      <Seo {...SEO.private} />
      <div className="container-pf">
        {query.isLoading && <p className="text-lg text-slate2">Caricamento…</p>}
        {query.isError && <Invalid message={formatApiError(query.error)} />}
        {query.data && (
          <div className="grid gap-12 lg:grid-cols-12">
            <div className="lg:col-span-5">
              <p className="eyebrow">Ordine {query.data.ref}</p>
              <h1 className="mt-5 font-display text-4xl font-medium leading-[1.05] text-navy sm:text-5xl lg:text-6xl">Com'è andata?</h1>
              <p className="mt-6 text-lg leading-relaxed text-slate2">Dai un voto a ciascun prodotto e, se vuoi, aggiungi due parole. La recensione comparirà nella scheda del prodotto con il nome <strong className="text-navy" data-testid="review-author">{query.data.author}</strong>.</p>
              <div className="mt-8"><VerifiedNotice /></div>
            </div>
            <ul className="space-y-6 lg:col-span-7">
              {items.map((item) => (
                <li key={item.slug} className="rounded-3xl border border-copper/20 bg-cream p-6 sm:p-8" data-testid={`review-item-${item.slug}`}>
                  <div className="flex items-center gap-5">
                    <img src={item.image} alt="" className="h-20 w-16 shrink-0 rounded-xl bg-parchment object-cover" />
                    <p className="font-display text-2xl text-navy sm:text-3xl">{item.name}</p>
                  </div>
                  {item.reviewed || done.includes(item.slug) ? <ReviewDone slug={item.slug} /> : <ReviewForm token={token} item={item} onDone={markDone} />}
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </div>
  );
}
